import { styled } from "@styles";

export const HeadingStyle = styled("h1", {
  lineHeight: "$base",
  color: "$neutral70",
  margin: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",

  cursor: "default",

  variants: {
    variant: {
      black: {
        color: "$neutral100",
      },
      veryDarkGray: {
        color: "$neutral90",
      },
      blackGray: {
        color: "$neutral80",
      },
      darkGray: {
        color: "$neutral70",
      },
      gray: {
        color: "$neutral60",
      },
      lightGray: {
        color: "$neutral50",
      },
      white: {
        color: "$neutral00",
      },
      error: {
        color: "$red40",
      },
      success: {
        color: "$green60",
      },
      "success-2": {
        color: "$green40",
      },
    },

    weight: {
      bold: {
        fontWeight: "$bold",
      },
      medium: {
        fontWeight: "$medium",
      },
      regular: {
        fontWeight: "$regular",
      },
      light: {
        fontWeight: "$light",
      },
    },

    size: {
      "xxx-large": {
        fontSize: "$40px",
        lineHeight: "$50px",
      },
      "xx-large": {
        fontSize: "$32px",
        lineHeight: "$50px",
      },
      "x-large": {
        fontSize: "$32px",
        lineHeight: "$32px",
      },
      large: {
        fontSize: "$24px",
        lineHeight: "$32px",
      },
      "large-2": {
        fontSize: "$20px",
        lineHeight: "$32px",
      },
      medium: {
        fontSize: "$18px",
        lineHeight: "$40px",
      },
      "medium-2": {
        fontSize: "$18px",
        lineHeight: "$24px",
      },
      small: {
        fontSize: "$16px",
        lineHeight: "$24px",
      },
      "x-small": {
        fontSize: "$14px",
        lineHeight: "$24px",
      },
      "xx-small": {
        fontSize: "$12px",
        lineHeight: "$14px",
      },
    },

    alignCenter: {
      true: {
        textAlign: "center",
      },
    },
  },

  defaultVariants: {
    weight: "bold",
    size: "medium",
  },
});
